let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jhwfj")).then(() => parcelRequire('h9oa9'));